const listeners = [];
export const exportEvents = {
    /**
     * Emit event when a new export is started
     */
    emitExportStarted: () => {
        listeners.forEach(callback => callback());
    },
    /**
     * Subscribe to export started events
     */
    onExportStarted: (callback) => {
        listeners.push(callback);
        // Return unsubscribe function
        return () => {
            const index = listeners.indexOf(callback);
            if (index > -1) {
                listeners.splice(index, 1);
            }
        };
    }
};
